import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MmuCookiePreferences } from '../mmu-cookie-preferences';


@Component({
  selector: 'mmu-cookie-selection',
  templateUrl: './mmu-cookie-selection.component.html',
  styleUrls: ['./mmu-cookie-selection.component.scss']
})
export class MmuCookieSelectionComponent {

  @Input()
  settings: MmuCookiePreferences = {
    required: true,
    statistics: false
  };

  @Input()
  formDisabled = false;

  @Output()
  settingsChange: EventEmitter<MmuCookiePreferences> = new EventEmitter<MmuCookiePreferences>();

  valueChanged(property: keyof MmuCookiePreferences, value: boolean): void {
    this.settings[property] = value;
    this.settingsChange.emit(this.settings);
  }
}
